'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupingTable$$anon$24(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_GroupingTable$$anon$24 as $c_Lpresto_GroupingTable$$anon$24 };
$p = $c_Lpresto_GroupingTable$$anon$24.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupingTable$$anon$24;
/** @constructor */
function $h_Lpresto_GroupingTable$$anon$24() {
}
export { $h_Lpresto_GroupingTable$$anon$24 as $h_Lpresto_GroupingTable$$anon$24 };
$h_Lpresto_GroupingTable$$anon$24.prototype = $p;
$p.aL = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, item.qd, $j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().crO());
});
var $d_Lpresto_GroupingTable$$anon$24 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupingTable$$anon$24, "presto.GroupingTable$$anon$24", ({
  JS: 1,
  z: 1
}));
export { $d_Lpresto_GroupingTable$$anon$24 as $d_Lpresto_GroupingTable$$anon$24 };
//# sourceMappingURL=presto.-Grouping-Table$$anon$24.js.map
